import React, { useState } from 'react';
import { tasks, users, pets } from '../mock/dailyTasks';
import DailySummary from '../components/DailySummary';
import TaskRow from '../components/TaskRow';
import TaskModal from '../components/TaskModal';

const TasksPage = () => {
  const [currentUser] = useState(users[2]); // Simulamos usuario logueado (admin)
  const [taskList, setTaskList] = useState(tasks);
  const [filter, setFilter] = useState('all');
  const [showModal, setShowModal] = useState(false);
  const [editingTask, setEditingTask] = useState(null);

  const caregivers = users.filter(user => user.role === 'caregiver');

  const handleStatusChange = (taskId, activityIndex, newStatus) => {
    setTaskList(prev => prev.map(task => {
      if (task.id === taskId) {
        const updatedActivities = [...task.activities];
        updatedActivities[activityIndex] = {
          ...updatedActivities[activityIndex],
          status: newStatus
        };
        return { ...task, activities: updatedActivities };
      }
      return task;
    }));
  };

  const handleSaveTask = (taskData, taskId) => {
    if (taskId) {
      // Editar tarea existente
      setTaskList(prev => prev.map(task => 
        task.id === taskId ? { ...task, ...taskData } : task
      ));
    } else {
      // Nueva tarea
      const newTask = {
        id: `task-${Date.now()}`,
        petId: taskData.petId,
        petName: pets.find(p => p.id === taskData.petId)?.name || '',
        petImage: pets.find(p => p.id === taskData.petId)?.image || '',
        activities: taskData.activities,
        ownerId: 'user-001' // En una app real esto vendría de la relación mascota-dueño
      };
      setTaskList(prev => [...prev, newTask]);
    }
    setShowModal(false);
    setEditingTask(null);
  };

  const handleDeleteTask = (taskId) => {
    setTaskList(prev => prev.filter(task => task.id !== taskId));
  };

  const handleEditTask = (task) => {
    setEditingTask(task);
    setShowModal(true);
  };

  const filteredTasks = taskList.filter(task => {
    if (currentUser.role === 'caregiver') {
      return task.activities.some(a => a.caregiver === currentUser.name);
    }
    if (currentUser.role === 'owner') {
      return task.ownerId === currentUser.id;
    }
    return true;
  }).filter(task => {
    if (filter === 'all') return true;
    return task.activities.some(a => a.status === filter);
  });

  return (
    <div className="ml-64">
      <DailySummary tasks={filteredTasks} />
      
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800">Tareas Diarias</h2>
          
          <div className="flex items-center space-x-4">
            <select
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-md text-sm"
            >
              <option value="all">Todas</option>
              <option value="pending">Pendientes</option>
              <option value="in-progress">En curso</option>
              <option value="completed">Completadas</option>
            </select>
            
            <input
              type="text"
              placeholder="Buscar mascota..."
              className="px-3 py-2 border border-gray-300 rounded-md text-sm"
            />

            {currentUser.role !== 'owner' && (
              <button
                onClick={() => {
                  setEditingTask(null);
                  setShowModal(true);
                }}
                className="flex items-center px-4 py-2 bg-cyan-600 text-white rounded-lg hover:bg-cyan-700"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
                Nueva Tarea
              </button>
            )}
          </div>
        </div>

        <div className="space-y-4">
          {filteredTasks.length > 0 ? (
            filteredTasks.map(task => (
              <TaskRow
                key={task.id}
                task={task}
                currentUser={currentUser}
                onStatusChange={handleStatusChange}
                onEdit={() => handleEditTask(task)}
                onDelete={() => handleDeleteTask(task.id)}
              />
            ))
          ) : (
            <div className="bg-white rounded-xl shadow-sm p-8 text-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6-2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h3 className="text-lg font-medium text-gray-800 mt-4">No hay tareas</h3>
              <p className="text-gray-500 mt-1">No se encontraron tareas con los filtros seleccionados</p>
            </div>
          )}
        </div>
      </div>

      {showModal && (
        <TaskModal
          pets={pets}
          caregivers={caregivers}
          onClose={() => {
            setShowModal(false);
            setEditingTask(null);
          }}
          onSave={handleSaveTask}
          taskToEdit={editingTask}
        />
      )}
    </div>
  );
};

export default TasksPage;